import React, { ReactElement, useState } from "react";
import { Report } from "../../types/Report";
import { useHistory } from "react-router-dom";

import { Card, CardBody, CardHeader, CardFooter } from "./styles";

interface ReportCardProps {
    Report: Report;
    disabled: boolean;
}

const ReportCard = ({ Report, disabled }: ReportCardProps): ReactElement => {
    const [isFavorite, setIsFavorite] = useState(false);
    const tagsArray: string[] | undefined = Report.tags
        ?.split(";")
        .filter((label) => label !== "");
    const history = useHistory();

    const openReportClick = (report: Report) => {
        if (!disabled) {
            history.push(`/reports/${report.id}`);
        }
    };

    const setFavoriteClick = (report: Report) => {
        if (!disabled) {
            setIsFavorite(!isFavorite);
        }
    };

    return (
        <>
            <Card disabled={disabled}>
                <CardHeader>
                    <h4 onClick={() => openReportClick(Report)}>
                        <span>{Report.name}</span>
                        <i className={`pi pi-chevron-right`} />
                    </h4>
                    {/* <div>
                        <i
                            className={
                                isFavorite ? "pi pi-heart-fill" : "pi pi-heart"
                            }
                            onClick={() => setFavoriteClick(Report)}
                        ></i>
                    </div> */}
                </CardHeader>
                <CardBody>{Report.description}</CardBody>
                <CardFooter>
                    {tagsArray &&
                        tagsArray.map((item, index) => (
                            <span key={index}>{item}</span>
                        ))}
                </CardFooter>
            </Card>
        </>
    );
};

export default ReportCard;
